import { render, staticRenderFns } from "./OrderTableBoxesModal.vue?vue&type=template&id=2e79b7ba&"
import script from "./OrderTableBoxesModal.vue?vue&type=script&lang=js&"
export * from "./OrderTableBoxesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports